import React from 'react'
import Butnaction from '../../../Components/Action/Butnaction'
import './project.css'

const Project = ({body, urole}) => {
    const handleselectedVal = (incoming) =>{
        // console.log(incoming)
    }

  return (
    <div className='project-right-detail'>
        <div className='project-right-sub-detail'>
            <div className='top-task-container-tab'>
                <div className='top-task-title-container'>
                    <span>{body[0].title}</span>
                </div>

                <div className='task-detailed-description'>
                    <span>{body[0].discription}</span>
                </div>

                <div className='date-task-container'>
                    <div className='start-task-container'>
                        <span>Start:</span>
                        <span>{body[0].start}</span>
                    </div>
                    
                    <div className='end-task-container'>
                        <span>End:</span>
                        <span>{body[0].stop}</span>
                    </div>
                </div>
            </div>

            <div className='underline'/>

            <div className='assiged-to-main-container'>
                <div className='assiged-to-container'>
                    <span>Assigned To:</span>
                    <span>{body[0].assignedto}</span>
                </div>

                <div className='assiged-to-container'>
                    <span>Assigned By:</span>
                    <span>{body[0].assignedby}</span>
                </div>
            </div>


            <div className='assiged-to-mains-container'>

                <div className='assiged-to-container'>
                    <span>Collaborators:</span>
                    <div className='btom-task-container-tab'>
                        {body[0].participants.map((item, index)=>(
                            <div key={index} className={`prt_image_container-${index+1}`} style={{backgroundImage: `url(${process.env.PUBLIC_URL + item.imgurl})`}}/>
                        ))}
                    </div>
                </div>

                <div className='assiged-tos-container'>
                    <span>Action:</span>
                    <Butnaction actionsta={(urole.fname === body[0].assignedto.split(' ')[0]) ? true : false} clickedval={handleselectedVal}/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Project